import { jsx as _jsx } from "react/jsx-runtime";
import "./drawingBorderButton.style.css";
export const DrawingBorderButton = ({ children, className, onClick, style = {} }) => {
    return (_jsx("button", { onClick: onClick, className: `drawingBtn draw-border ${className}`, style: { ...style }, children: children }));
};
